import type { HelpFile } from '../../types/help'
import { TypesTestIds } from '../../../testids/TypesTestIds'

export const typesHelp: HelpFile = {
  docPage: '/docs/schema/types',
  texts: {
    [TypesTestIds.typesPage]:
      'Im Schema definierte Entitätstypen — Bausteine für Parteien, Identitäten, Konten und eigene Domänenobjekte.',
  },
}
